// src/games/core/api.ts
import { apiNode } from '../../services/api';
import { finishTempo } from './session/time';

export const RANKING_TIPO = { rebus: 5, quiz: 6, wordsearch: 7, sudoku: 8 } as const;
export type RankingTipo = typeof RANKING_TIPO[keyof typeof RANKING_TIPO];

export interface RankingPositionBody {
  id_jogo: number;
  id_user: number;
  id_tipo: RankingTipo;
  pontuacao: number;
  tempo: number;
}

/** POST create_ranking_position — o erro sobe para o fim traduzir pela tabela. */
export async function createRankingPosition(body: RankingPositionBody): Promise<void> {
  await apiNode.post('/create_ranking_position', {
    ...body,
    pontuacao: Number.isFinite(body.pontuacao) ? Math.max(0, Math.round(body.pontuacao)) : 0,
    tempo: finishTempo(body.tempo),
  });
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

/** Jogos avulsos aparecem no /historico como `passatempo` com o id do JOGO. */
export function isJogoCompletedIn(historico: unknown, jogoId: number, tipo: number): boolean {
  if (!Array.isArray(historico)) return false;
  return historico.some(
    (entry) =>
      isRecord(entry) &&
      entry.kind === 'passatempo' &&
      entry.id === jogoId &&
      entry.tiposDePassatemposId === tipo &&
      entry.status === 'completed'
  );
}

/**
 * O erro SOBE: tratar a falha como "não concluído" reabriria jogável um jogo já terminado
 * (Review Focus: uma requisição que falha impede abrir o jogo).
 */
export async function isJogoCompleted(jogoId: number, tipo: number): Promise<boolean> {
  const { data } = await apiNode.get<unknown>('/historico');
  return isJogoCompletedIn(data, jogoId, tipo);
}
